<template>
  <section class="high-efficency-google-lens">
    <div class="high-efficency-google-lens-sticky">
      <div v-textMotion="50" class="google-lens-text-intro">
        <p class="title">{{ $t('google-lens-title') }}</p>
        <p class="sub-title">{{ $t('google-lens-sub-title') }}</p>
        <p class="description">
          {{ $t('google-lens-description') }}
        </p>
      </div>
      <div
        class="google-lens-phone-container wow textInPartMotion"
        data-wow-duration=".7s"
        data-wow-delay="0s"
        :data-wow-offset="100"
        :style="{
          transform: `translate3d(0, ${findx2TranslateY}px, 0)`
        }"
      >
        <img
          ref="phone"
          v-lazy="require('../../assets/highEfficiency/phone.png')"
          alt="ColorOS 11"
          class="google-lens-phone-img"
        />
        <img
          ref="phonebg"
          v-lazy="require('../../assets/highEfficiency/bg1.jpg')"
          alt="ColorOS 11"
          class="google-lens-phone-bg"
        />
        <img
          ref="phonebg"
          v-lazy="require('../../assets/highEfficiency/bg2.jpg')"
          alt="ColorOS 11"
          class="google-lens-phone-bg google-lens-bg2"
          :style="{
            opacity: bg2Opacity
          }"
        />
        <img
          ref="phonebg"
          v-lazy="require('../../assets/highEfficiency/bg3.jpg')"
          alt="ColorOS 11"
          class="google-lens-phone-bg google-lens-bg3"
          :style="{
            opacity: bg3Opacity
          }"
        />
      </div>
    </div>
  </section>
</template>

<script>
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
import UpdateAnimationMixin from '../../mixins/updateAnimation';

export default {
  mixins: [UpdateAnimationMixin],
  data() {
    return {
      progress: 0
    };
  },
  computed: {
    findx2TranslateY() {
      let findx2TranslateY = 0;
      const progress = this.progress;
      if (progress < 1 && window.innerWidth > 734) {
        findx2TranslateY = progress * (-0.25 * window.innerHeight);
      } else if (window.innerWidth > 734) {
        findx2TranslateY = -0.25 * window.innerHeight;
      }
      return findx2TranslateY;
    },
    bg2Opacity() {
      const progress = this.progress;
      if (progress < 0.25 && window.innerWidth < 734) {
        return 0;
      } else if (progress < 0.35 && window.innerWidth >= 734) {
        return 0;
      }
      return 1;
    },
    bg3Opacity() {
      const progress = this.progress;
      if (progress < 0.7) {
        return 0;
      }
      return 1;
    }
  },
  mounted() {
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
  },
  methods: {
    initScroll() {
      this.scene = new ScrollMagic.Scene({
        duration: 1.5 * window.innerHeight,
        triggerElement: '.high-efficency-google-lens',
        triggerHook: 0
      })
        .setPin('.high-efficency-google-lens-sticky')
        .addTo(Controller)
        .on('progress', e => {
          this.updateBezier('progress', e.progress, 300);
        });
      this.scene.progress(1);
    },
    initMobie() {
      this.scene = new ScrollMagic.Scene({
        duration: 500,
        triggerElement: '.high-efficency-google-lens',
        triggerHook: 0,
        offset: 210
      })
        .setPin('.high-efficency-google-lens-sticky')
        .addTo(Controller)
        .on('progress', e => {
          this.updateBezier('progress', e.progress, 300);
        });
      // this.scene.progress(1);
    },
    resizeHandler() {
      if (window.innerWidth < 734 && !this.scene) {
        this.initMobie();
      } else if (window.innerWidth >= 734 && !this.scene) {
        this.initScroll();
      }
      // 防止高度变化导致的裁切问题
      // if (this.scene) this.scene.duration(.5 * window.innerHeight);
    }
  }
};
</script>
<style lang="scss" scoped>
.high-efficency-google-lens {
  .high-efficency-google-lens-sticky {
    height: 100vh;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
  }
  .google-lens-text-intro {
    max-width: 512px;
    z-index: 3;
    margin-right: 100px;
    .title {
      font-weight: 500;
    }
    .sub-title {
      font-size: 36px;
    }
  }
  .google-lens-phone-img {
    height: 99vh;
    margin-top: 13vh;
  }
  .google-lens-phone-bg {
    opacity: 1;
    height: 95vh;
    z-index: -1;
    position: absolute;
    top: calc(2.2%);
    left: 2%;
    border-radius: 10px;
    margin-top: 13vh;
    transition: opacity 0.3s;
    // 防止图片模糊，据说mac上的有用，window上的没有效果
    image-rendering: -webkit-optimize-contrast;
  }
  .google-lens-bg2,
  .google-lens-bg3 {
    opacity: 0;
  }
  .google-lens-phone-container {
    z-index: 3;
    height: 100vh;
    position: relative;
  }
}
@media screen and (max-width: 960px) {
  .high-efficency-google-lens {
    .google-lens-phone-img {
      width: 45.625vw;
      height: auto;
    }
    .google-lens-phone-bg {
      width: 43.7vw;
      height: auto;
      top: 1.8%;
    }
  }
}
@media screen and (max-width: 734px) {
  .high-efficency-google-lens {
    .high-efficency-google-lens-sticky {
      height: 881px;
      width: 100%;
      position: relative;
      padding: 0 20px;
      flex-wrap: wrap;
      align-items: flex-start;
      box-sizing: border-box;
    }
    .google-lens-text-intro {
      margin-right: 0;
      margin-top: 61px;
      .sub-title {
        font-size: 24px;
      }
      .description {
        font-size: 13px;
      }
    }
    .google-lens-phone-container {
      height: auto;
      width: 64.53vw;
      margin: 0 auto;
    }
    .google-lens-phone-img {
      margin-top: 40px;
    }
    .google-lens-phone-bg {
      margin-top: 40px;
      transition: opacity 0.6s;
    }
    .google-lens-phone-img {
      width: 64.53vw;
      max-width: 242.5px;
      height: auto;
      margin-bottom: 60px;
    }
    .google-lens-phone-bg {
      width: 62vw;
      max-width: 232px;
      height: auto;
      top: 1.8%;
      left: 1.1%;
    }
  }
}
@media screen and (max-width: 500px) {
  .high-efficency-google-lens {
    .google-lens-phone-bg {
      left: 1.5%;
    }
  }
}
@media screen and (max-width: 380px) {
  .high-efficency-google-lens {
    .google-lens-phone-bg {
      left: 2.2%;
      width: 61.6vw;
    }
  }
}
</style>
